// Level thresholds: total XP required to reach each level
const LEVEL_THRESHOLDS = [0, 100, 400, 1000];

export interface LevelProgress {
  current: number;
  required: number;
  percent: number;
  nextLevelAt: number | null; // Total XP needed for next level, null if max
}

export function getLevelProgress(xp: number, level: number): LevelProgress {
  // Max level reached
  if (level >= 4) {
    return { current: xp, required: xp, percent: 100, nextLevelAt: null };
  }

  const currentLevelXp = LEVEL_THRESHOLDS[level - 1];
  const nextLevelXp = LEVEL_THRESHOLDS[level];
  const required = nextLevelXp - currentLevelXp;
  const current = xp - currentLevelXp;
  const percent = Math.round((current / required) * 100);

  return { current, required, percent, nextLevelAt: nextLevelXp };
}
